import { FC, memo, useEffect, useRef, useState, useTransition } from 'react';
import { Button } from '../../../components/Button';
import { InfoBlockItem } from '../../../components/InfoBLockItem';
import { NavLinkWithCopyText } from '../../../components/NavLinkWithCopyText';
import { tips } from '../../../constants/tips';
import { useIsOpen } from '../../../hooks/useIsOpen';
import { ITransaction } from '../../../types/transaction';

interface ResizebleCardProps {
  data: ITransaction;
}

const ResizebleCard: FC<ResizebleCardProps> = ({ data }) => {
  const { isOpen, handleToggle } = useIsOpen(false);
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number>(0);
  const [_, startTransition] = useTransition();

  useEffect(() => {
    if (ref.current) {
      const resizeObserver = new ResizeObserver(([elem]) => {
        startTransition(() => {
          setHeight(elem.contentRect.height);
        });
      });
      resizeObserver.observe(ref.current);
    }
  }, [ref.current]);

  return (
    <>
      <div className='animate' style={{ height: isOpen ? height : 0 }}>
        <div ref={ref}>
          {data.errorMessage && <InfoBlockItem name='Error message' value={data.errorMessage} />}
          <InfoBlockItem
            name='Block ID'
            tooltip={tips.block}
            value={<NavLinkWithCopyText path={`/blocks/${data.block}`} text={data.block} />}
          />
          <InfoBlockItem name='Deadline' tooltip={tips.deadline} value={data.deadline.toString()} />
          <InfoBlockItem
            name='Sender pubkey'
            tooltip={tips.senderPublicKey}
            value={data.senderPublicKey}
          />
          <InfoBlockItem name='EC Block' tooltip={tips.ecBlockId} value={data.ecBlockId} />
          <InfoBlockItem name='Signature' tooltip={tips.signature} value={data.signature} />
          <InfoBlockItem
            name='Signature hash'
            tooltip={tips.signatureHash}
            value={data.signatureHash}
          />
          <InfoBlockItem
            name='Full hash'
            tooltip={tips.fullHash}
            value={
              <NavLinkWithCopyText
                path={`/transactions/${data.fullHash}?fullHash`}
                text={data.fullHash}
              />
            }
          />
          <InfoBlockItem name='Version' tooltip={tips.version} value={data.version} />
          <InfoBlockItem
            name='Confirmations'
            tooltip={tips.confirmations}
            value={data.confirmations}
          />
        </div>
      </div>
      <div className='justify-content-center d-flex margin-top padding-bottom'>
        <Button onClick={handleToggle}>{!isOpen ? 'Show more' : 'Show less'}</Button>
      </div>
    </>
  );
};

export default memo(ResizebleCard);
